import { createSlice } from '@reduxjs/toolkit';
import { ClaimsImportStateType } from 'src/types/claimsImport';

const initialState: ClaimsImportStateType = {
    files: [],
    loading: false,
};

export const claimsImportSlice = createSlice({
    name: 'claimsImport',
    initialState,
    reducers: {
        addFile: (state, action) => {
            state.files = [...state.files, { file: action.payload, loading: true }];
        },
        deleteFile: (state, action) => {
            state.files = state.files.filter((file) => file.file.name !== action.payload.name);
        },
        validateFileImportFetch: (_state, _action) => {},
        validateFileImportFetchSuccess: (state, action) => {
            state.files = state.files.map((file) => {
                if (file.file.name === action.payload.file.name) {
                    return {
                        ...file,
                        loading: false,
                        validation: action.payload.validation,
                    };
                }
                return file;
            });
        },
        validateFileImportFetchFailure: (state, action) => {
            state.files = state.files.map((file) => {
                if (file.file.name === action.payload.file.name) {
                    return {
                        ...file,
                        loading: false,
                        error: action.payload.errorMessage,
                    };
                }
                return file;
            });
        },
        importClaimsFetch: (state) => {
            state.loading = true;
        },
        importClaimsFetchSuccess: (state, action) => {
            state.loading = false;
            state.files = state.files.map((file) => ({
                ...file,
                imported: true,
            }));
            void action;
        },
        importClaimsFetchFailure: (state, action) => {
            state.loading = false;
            void action;
        },
        clearClaimsImport: () => initialState,
    },
});

export const {
    addFile,
    deleteFile,
    validateFileImportFetch,
    validateFileImportFetchSuccess,
    validateFileImportFetchFailure,
    importClaimsFetch,
    importClaimsFetchSuccess,
    importClaimsFetchFailure,
    clearClaimsImport,
} = claimsImportSlice.actions;

export default claimsImportSlice.reducer;
